import React from 'react';
import { X } from 'lucide-react';
import { palette } from '../../../utils/designTokens';
import { feedbackIconStyle } from './rcaHelpers';
import { FeedbackGlyph } from './RcaPrimitives';

export default function NoteModal({
  busy,
  note,
  onNoteChange,
  onClose,
  onSubmit,
  title,
  description,
  placeholder = 'Optional note',
  submitLabel = 'Submit',
  tone = 'danger',
  icon = null,
  requireNote = false,
}) {
  const color = tone === 'success' ? palette.status.success : palette.status.danger;
  const submitDisabled = busy || (requireNote && !note.trim());
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-xl border border-border-subtle bg-background-primary shadow-xl">
        <div className="flex items-start justify-between gap-4 border-b border-border-subtle px-5 py-4">
          <div>
            <div className="flex items-center gap-2 text-sm font-semibold text-text-primary">
              <span style={{ color }}>
                {icon || <FeedbackGlyph type="down" active size={16} />}
              </span>
              {title}
            </div>
            <p className="mt-1 text-xs leading-relaxed text-text-muted">
              {description}
            </p>
          </div>
          <button
            type="button"
            aria-label="Close note"
            className="rounded p-1 text-text-muted hover:bg-background-tertiary hover:text-text-primary"
            onClick={onClose}
            disabled={busy}
          >
            <X size={16} />
          </button>
        </div>
        <div className="space-y-3 px-5 py-4">
          <textarea
            value={note}
            onChange={(event) => onNoteChange(event.target.value)}
            className="min-h-[120px] w-full rounded border border-border-subtle bg-background-secondary px-3 py-2 text-sm text-text-primary outline-none focus:border-accent-primary-base"
            placeholder={placeholder}
            autoFocus
          />
          <div className="flex justify-end gap-2">
            <button
              type="button"
              disabled={busy}
              className="rounded border border-border-subtle px-3 py-2 text-xs text-text-primary hover:bg-background-tertiary disabled:opacity-50"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={submitDisabled}
              className="rounded border px-3 py-2 text-xs font-medium disabled:opacity-50"
              style={feedbackIconStyle(true, color)}
              onClick={onSubmit}
            >
              {submitLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
